// import { ViewSupport49Component } from "../../../components/SupportSystem/ViewReports/ViewSupport49Component";
import { OperationReport49Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport49Component ";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ViewSupport49Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-9)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport49Component />
            <Footer />
        </div>
    );
}
